import React, { memo } from 'react'
import { advertiserDashboardMenu } from '../../data/Menu'
import PopulateMenu from './PopulateMenu'

const AdvertiserMenu = ({ toggleMenu, onUpdateSize, advertiserId, title, language }) => (
    <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
            {title}
        </div>
        <PopulateMenu menuItems={advertiserDashboardMenu} advertiserId={advertiserId} onUpdateSize={onUpdateSize} language={language} />
    </div>
)

export default memo(AdvertiserMenu)
